import { useQuery } from '@tanstack/react-query'

import { RequestsService } from '../lib/requests.service'

const RATE_PARAMETERS = 'rate-parameters'

export const useRateParameters = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [RATE_PARAMETERS],
    queryFn: () => RequestsService.getRateParameters(),
    select: response => response.data
  })

  return { data, isLoading, isError, error }
}
